import { useRegisterSW } from 'virtual:pwa-register/vue'

const period = 30 * 1000

export function initBackgroundSW() {
  const { updateServiceWorker } = useRegisterSW({
    immediate: true,
    onRegisteredSW(swUrl, r) {
      if (r) {
        r.onupdatefound = () => {
          window.localStorage.setItem('swNeedsUpdate', 'true')
        }
        void checkForUpdates(swUrl, r)
        setInterval(async () => {
          await checkForUpdates(swUrl, r)
        }, period)
      }
    }
  })

  return updateServiceWorker
}

async function checkForUpdates(swUrl: string, r: ServiceWorkerRegistration) {
  if (r.installing || !navigator) return

  if ('connection' in navigator && !navigator.onLine) return

  const resp = await fetch(swUrl, {
    cache: 'no-store',
    headers: {
      cache: 'no-store',
      'cache-control': 'no-cache'
    }
  })

  if (resp?.status === 200) await r.update()
}
